import { ENetwork } from 'web3';

export const QUERY_KEY_DEX_GAS_PRICE = 'dexGasPrice';

export const buildDexGasPriceQueryKey = (network: ENetwork) =>
  [QUERY_KEY_DEX_GAS_PRICE, network] as const;
